// Paging for list tables: at most PAGE_SIZE rows at once (see components/ui/Paging.tsx).

import { useState } from 'react';

export const PAGE_SIZE = 50;

/**
 * The rows for the current page. `resetKey` is anything that changes when
 * the list is re-filtered (search, filters, the picked company…); a change
 * jumps back to page 1.
 */
export function usePaging<T>(rows: T[], resetKey = '') {
  const [page, setPage] = useState(1);
  const [lastKey, setLastKey] = useState(resetKey);
  if (lastKey !== resetKey) { setLastKey(resetKey); setPage(1); }
  const totalPages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
  const current = Math.min(page, totalPages);
  const pageRows = rows.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE);
  return { page: current, setPage, totalPages, pageRows, total: rows.length };
}
